/**
 * Shared types and constants for engagement views and navigation
 */

// Navigation mode for engagement forms
export type NavigationMode = 'setup' | 'existing'

// Tab constants for engagement view
export const ENGAGEMENT_TABS = {
  DETAILS: 'details',
  OVERVIEW: 'overview'
} as const

export type EngagementTab = typeof ENGAGEMENT_TABS[keyof typeof ENGAGEMENT_TABS]

